<template>
  <div>
    <div class="ui form" id="room-form" style="margin-bottom: 60px">
      <div class="required field">
        <label for="name">Name</label>
        <div class="ui input">
          <input type="text" v-model="room.name" name="name">
        </div>
      </div>

      <div class="field">
        <label for="medical-machine-ids">Choose Medical Machines</label>
        <select
          class="ui fluid search dropdown"
          id="medical-machine-search"
          multiple="[]"
          v-model="room.medical_machine_ids"
          name="medicalMachineIds"
        >
          <option value="">Choose Medical Machines</option>
          <option :value="medicalMachine.id" v-for="medicalMachine in medicalMachines" :key="medicalMachine.id">
            {{ medicalMachine.name }}
          </option>
        </select>
      </div>

      <div
        class="ui blue right floated button"
        style="background-color: #092442"
        :class="{ disabled: !isFormValid }"
        @click="submit()"
      >
        Submit
      </div>
    </div>
    <div class="ui positive message" v-if="showSuccessMessage" :key="successMessageKey">
      <strong>{{createdRoomName}}</strong> has been created Successfully
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      room: {
        name: '',
        medical_machine_ids: []
      },
      isFormValid: false,
      medicalMachines: [],
      showSuccessMessage: false,
      successMessageKey: 0,
      createdRoomName: ''
    }
  },
  watch: {
    room: {
      handler: function () {
        this.isFormValid = !!this.room.name
      },
      deep: true
    }
  },
  mounted () {
    this.$http.get('/medical_machines/meta', {
      params: {
        clinic_id: this.getClinicId()
      }
    }).then(response => {
      this.medicalMachines = response.data
      this.initGUI()
    })
  },
  methods: {
    initGUI() {
      this.$nextTick(() => {
        $('#medical-machine-search').dropdown();
        $('#room-form').form({
          inline: true,
          on: 'blur',
          fields: {
            name: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, enter room name.'
                }
              ]
            }
          }
        });
      })
    },
    submit () {
      this.$http.post('/rooms', { 
        room: this.room,
        clinic_id: this.getClinicId()
      }).then(response => {
        this.createdRoomName = response.data.name
        this.showSuccessMessage = true
        ++this.successMessageKey
      })
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rooms/RoomForm.vue